exports = module.exports = require("../../../../../employee/node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".wizard-footer {\n  background-color: #ffffff;\n  -webkit-box-shadow: 0 -2px 4px 0 rgba(0, 0, 0, 0.24);\n          box-shadow: 0 -2px 4px 0 rgba(0, 0, 0, 0.24);\n  padding: 16px 16px 16px;\n  position: fixed !important;\n  bottom: 0;\n  left: 0;\n  width: 100vw;\n  z-index: 1000; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!../lib/egov-ui-kit/common/common/ActionFooter/index.css
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!../lib/egov-ui-kit/common/common/ActionFooter/index.css
// module chunks = 504